var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-dark-blue2)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M13.125 2.625h3.5a1.75 1.75 0 0 1 1.75 1.75v12.25a1.75 1.75 0 0 1-1.75 1.75h-3.5M8.75 14.875l4.375-4.375L8.75 6.125M12.125 10.5h-10.5"
  })));
};
export default SvgLogin;